<template>
  <div style="color:#6c757d !important;">
    <!-- ----------------------------------- -->
    <!-- navbar starts -->
    <vs-navbar
      v-model="indexActive"
      :color="colorx"
      text-color="rgba(255,255,255,.6)"
      active-text-color="rgba(255,255,255,1)"
      class="myNavbar"
    >
      <div slot="title">
        <vs-navbar-title class="print-scr">Graphs Presentations</vs-navbar-title>
      </div>
    </vs-navbar>
    <!-- navbar ends -->
    <!-- ----------------------------------- -->
    <!-- container starts -->
    <div class="container container-bdr mt-5 mb-5">
      <!-- row starts -->
      <div class="row">
        <vs-breadcrumb
          align="left"
          :items="
                  [
                   {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Advisor/AdvisorDashboard'
                    },
                    {
                      title: 'No Of Trainees',
                      url: '/#/dashboard/Advisor/trainingReport',
                      active: true
                    }
                  ]"
        ></vs-breadcrumb>
        <div class="col-sm-12">
          <span class="btn btn-primary float-right btn-sm print-btn" @click="printReport">
            <i class="material-icons">print</i> Print
          </span>
        </div>
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-12 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Pre & Post Assessment Report</strong>
            </span>
            <span class="float-right">
              <strong>Event Code :</strong> T327
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom">
          <img :src="basepath+'/unodc_logo.png'" class="mt-2 mb-2" alt="UNODC" width="200" />
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Plot # 5-11, Diplomatic Enclave, G-5, P.O.BOX 1051, Islamabad 44000, Pakistan</strong>
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Country Office Pakistan</strong>
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-12 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Name of Event :</strong> Training on "Administrative Management, Managing Audit and Accounts"
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-8 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Start Date :</strong> 10/30/2019
            </span>
            <span class="float-right">
              <strong>Finish Date :</strong> 12/30/2019
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Output :</strong> 2.1(PACT)
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-6 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Total Pre-Assessment Forms :</strong> 27
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-6 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Total Post-Assessment Forms :</strong> 27
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-12 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Name of Trainer(s) :</strong> Barrister Ehtasham Anwar
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
      </div>
    </div>
    <!-- ----------------------------------- -->
    <!-- container starts -->
    <div class="container container-bdr mt-5 mb-5">
      <!-- row starts -->
      <div class="row">
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-6">
          <p class="mt-2 mb-2">
            <span>
              <h3 class="h-three">Training Report</h3>
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-6">
          <p class="mt-2 mb-2"></p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-5">
          <!-- --------------------------  -->
          <!-- nested row starts  -->
          <div class="row">
            <!-- --------------------------  -->
            <!-- nested column starts  -->
            <div class="col-md-12">
              <p class="mt-2 mb-2">
                <span>
                  <h5 class="h-five">Training on crime scene investigation for Punjab Police</h5>
                </span>
              </p>
            </div>
            <!-- nested column ends  -->
            <!-- --------------------------  -->
            <!-- nested column starts  -->
            <div class="col-md-12">
              <p class="mt-2 mb-2">
                <span>
                  <strong>Conducted By -</strong> Muhammad Amjad Chaudhry
                </span>
              </p>
              <p class="mt-2 mb-2">
                <span>
                  <strong>Conducted On -</strong> 25th December, 2018
                </span>
              </p>
            </div>
            <!-- nested column ends  -->
            <!-- --------------------------  -->
            <!-- nested column starts  -->
            <div class="col-md-12">
              <p class="mt-2 mb-2">
                <span>
                  <strong style="text-transform:uppercase;">List of Participants</strong> (40 Persons)
                </span>
              </p>
              <ul class="participants-list">
                <li>Muhammad Laraib Khan</li>
                <li>Mohsin Abid</li>
                <li>Ahsan Sohail</li>
                <li>Abdullah Sohail</li>
                <li>Muhammad Laraib Khan</li>
                <li>Mohsin Abid</li>
                <li>Ahsan Sohail</li>
                <li>Abdullah Sohail</li>
                <li>Muhammad Laraib Khan</li>
                <li>Mohsin Abid</li>
                <li>Ahsan Sohail</li>
                <li>Abdullah Sohail</li>
                <li>Muhammad Laraib Khan</li>
                <li>Mohsin Abid</li>
                <li>Ahsan Sohail</li>
                <li>Abdullah Sohail</li>
                <li>Muhammad Laraib Khan</li>
                <li>Mohsin Abid</li>
                <li>Ahsan Sohail</li>
                <li>Abdullah Sohail</li>
                <li>Muhammad Laraib Khan</li>
                <li>Mohsin Abid</li>
                <li>Ahsan Sohail</li>
                <li>Abdullah Sohail</li>
                <li>Muhammad Laraib Khan</li>
                <li>Mohsin Abid</li>
                <li>Ahsan Sohail</li>
                <li>Abdullah Sohail</li>
                <li>Muhammad Laraib Khan</li>
                <li>Mohsin Abid</li>
                <li>Ahsan Sohail</li>
                <li>Abdullah Sohail</li>
              </ul>
            </div>
            <!-- nested column ends  -->
          </div>
          <!-- nested row ends  -->
          <!-- --------------------------  -->
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-7">
          <!-- --------------------------  -->
          <!-- nested row starts  -->
          <div class="row">
            <!-- --------------------------  -->
            <!-- nested column starts  -->
            <div class="col-md-6">
              <p class="mt-5 mb-2 text-center">
                <span>
                  <h5 class="h-five">Male/Female</h5>
                </span>
              </p>
              <canvas id="myPieChart" width="400" height="400"></canvas>
            </div>
            <!-- nested column ends  -->
            <!-- --------------------------  -->
            <!-- nested column starts  -->
            <div class="col-md-6">
              <p class="mt-5 mb-2 text-center">
                <span>
                  <h5 class="h-five">Knowledge Change</h5>
                </span>
              </p>
              <canvas id="bar-chart-grouped" width="400" height="400"></canvas>
            </div>
            <!-- nested column ends  -->
            <!-- --------------------------  -->
            <!-- nested column starts  -->
            <div class="col-md-12">
              <p class="mt-5 mb-2 text-center">
                <span>
                  <h5 class="h-five">Trained Before on This Subject</h5>
                </span>
              </p>
              <canvas id="bar-chart-horizontal" width="400" height="100"></canvas>
            </div>
            <!-- nested column ends  -->
            <!-- --------------------------  -->
            <!-- nested column starts  -->
            <!-- Question 1 starts  -->
            <div class="col-md-12">
              <p class="mt-5 mb-2">
                <span>
                  <h5 class="h-five">Question No. 1</h5>
                </span>
              </p>
              <p class="mt-2 mb-2">
                <span>
                  <h6 class="h-six">Lorem ipsum dolor, sit amet consectetur adipisicing elit ?</h6>
                </span>
              </p>
            </div>
            <div class="col-md-12">
              <canvas id="ques-1-options" width="400" height="150"></canvas>
            </div>
            <!-- Question 1 ends  -->
            <!-- nested column ends  -->
            <!-- --------------------------  -->
            <!-- nested column starts  -->
            <!-- Question 1 starts  -->
            <div class="col-md-12">
              <p class="mt-5 mb-2">
                <span>
                  <h5 class="h-five">Question No. 2</h5>
                </span>
              </p>
              <p class="mt-2 mb-2">
                <span>
                  <h6 class="h-six">Lorem ipsum dolor, sit amet consectetur adipisicing elit ?</h6>
                </span>
              </p>
            </div>
            <div class="col-md-12">
              <canvas id="ques-2-options" width="400" height="150"></canvas>
            </div>
            <!-- Question 1 ends  -->
            <!-- nested column ends  -->
            <!-- --------------------------  -->
          </div>
          <!-- nested row ends  -->
          <!-- --------------------------  -->
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
      </div>
      <!-- row ends -->
    </div>
    <!-- container ends -->
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import Chart from "chart.js";
export default {
  data: () => ({
    colorx: "#2196f3",
    indexActive: 1,
    basepath: ""
  }),
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.basepath = localStorage.getItem("BASE_PATH");
    // chart 1 starts
    var ctx2 = document.getElementById("myPieChart");
    var myPieChart = new Chart(ctx2, {
      type: "pie",
      data: {
        labels: ["Male", "Female"],
        datasets: [
          {
            backgroundColor: ["#2196f3", "#f320bc"],
            data: [35, 65]
          }
        ]
      }
    });
    //chart 1 ends
    // chart 2 starts
    var ctx = document.getElementById("bar-chart-grouped");
    var myChart = new Chart(ctx, {
      type: "bar",
      data: {
        labels: ["Pre-Training", "Post-Training"],
        datasets: [
          {
            label: "Pre-Training",
            data: [0, 40],
            backgroundColor: ["#2196f3", "#2196f3"]
          },
          {
            label: "Post-Training",
            data: [60, 0],
            backgroundColor: ["#f320bc", "#f320bc"]
          }
        ]
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                max: 100,
                callback: function(value) {
                  return value + "%";
                }
              },
              scaleLabel: {
                display: true,
                labelString: "Percentage"
              }
            }
          ]
        }
      }
    });
    // chart 2 ends
    // chart 3 starts
    new Chart(document.getElementById("bar-chart-horizontal"), {
      type: "horizontalBar",
      data: {
        labels: ["Yes", "No"],
        datasets: [
          {
            label: "",
            backgroundColor: [
              "#3e95cd",
              "#8e5ea2",
              "#3cba9f",
              "#e8c3b9",
              "#c45850"
            ],
            data: [25, 70]
          }
        ]
      },
      options: {
        scales: {
          xAxes: [
            {
              ticks: {
                min: 0,
                max: 100,
                callback: function(value) {
                  return value + "%";
                }
              },
              scaleLabel: {
                display: true,
                labelString: "Percentage"
              }
            }
          ]
        },
        legend: { display: false }
      }
    });
    // chart 3 ends
    //------ questions chart starts --------------------------
    //Question 1 options chart starts
    new Chart(document.getElementById("ques-1-options"), {
      type: "horizontalBar",
      data: {
        labels: ["Option 1", "Option 2", "Option 3", "Option 4"],
        datasets: [
          {
            label: "",
            backgroundColor: [
              "#3e95cd",
              "#8e5ea2",
              "#3cba9f",
              "#e8c3b9",
              "#c45850"
            ],
            data: [15, 23, 12, 50]
          }
        ]
      },
      options: {
        scales: {
          xAxes: [
            {
              ticks: {
                min: 0,
                max: 100,
                callback: function(value) {
                  return value + "%";
                }
              },
              scaleLabel: {
                display: true,
                labelString: ""
              }
            }
          ]
        },
        legend: { display: false }
      }
    });
    // Question 1 options chart ends
    //Question 2 options chart starts
    new Chart(document.getElementById("ques-2-options"), {
      type: "horizontalBar",
      data: {
        labels: ["Option 1", "Option 2", "Option 3", "Option 4"],
        datasets: [
          {
            label: "",
            backgroundColor: [
              "#3e95cd",
              "#8e5ea2",
              "#3cba9f",
              "#e8c3b9",
              "#c45850"
            ],
            data: [15, 23, 12, 50]
          }
        ]
      },
      options: {
        scales: {
          xAxes: [
            {
              ticks: {
                min: 0,
                max: 100,
                callback: function(value) {
                  return value + "%";
                }
              },
              scaleLabel: {
                display: true,
                labelString: ""
              }
            }
          ]
        },
        legend: { display: false }
      }
    });
    // Question 2 options chart ends
  },
  methods: {
    printReport: function() {
      window.print();
    }
  }
};
</script>
<style scoped>
.myNavbar {
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1), 0 5px 5px rgba(0, 0, 0, 0.1) !important;
}
/* .container-bdr {
  border-top: 1px solid #ebe9e9;
  border-right: 1px solid #ebe9e9;
} */
/* .col-bdr-bottom {
  border-bottom: 0.5px solid #ebe9e9;
  border-left: 0.5px solid #ebe9e9;
} */
.nav-route-link {
  background: none !important;
  border-right: 0px !important;
}
.h-three {
  color: #2196f3 !important;
}
.h-five {
  font-size: 18px;
}
.h-six {
  font-size: 16px;
}
ul.participants-list li {
  padding: 5px 0px;
}
/* .cont-bdr {
  display: none;
} */
@media print {
  .print-scr {
    display: none;
  }
  .print-btn {
    display: none;
  }
  .cont-bdr {
    display: block;
  }
  .heading {
    display: none;
  }
}
</style>
<style>
.vs-navbar--header {
  height: 60px;
  padding: 20px;
}
.vs-con-items {
  padding: 20px;
}

@media screen and (max-width: 800px) {
  .vs-con-items.activeMenuResponsive {
    background-color: #46637a !important;
  }
}
</style>